import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

import insmed_logo from "../../assets/dexcom-logo.png";

import "./header.css";

const Loginheader = () => {
  return (
    <Box>
      <AppBar position="static" color="transparent" className="app-bar">
        <Toolbar>
          <img
            key="logo"
            src={insmed_logo}
            alt="logo"
            className="logo"
            style={{ cursor: "pointer" }}
          />
        </Toolbar>
      </AppBar>
    </Box>
  );
};
export default Loginheader;
